module.exports = require("@iconify/react");